<template>
  <div
    class="event-card"
    :class="{
      startAfternoon: leavePeriod.startsAfternoon,
    }"
    :id="leavePeriod.details.id"
    :style="{
      width: leavePeriod.duration * columnWidth + unityColumnWidth,
    }"
    @mouseup="showEvent($event, leavePeriod)"
  >
    <div class="iconsOptions">
      <div
        class="redDot mt-1"
        v-if="leavePeriod.details.comments"
        :title="leavePeriod.details.comments"
      ></div>
    </div>

    <p v-bind:style="{ background: leavePeriod.color }">
      {{
        $enumLeavePeriodType.find((l) => l.value === leavePeriod.details.type)
          .text
      }}
      <!-- {{ `${$t("gridLeavePeriod.titre")} ${leavePeriod.details.type}` }} -->
    </p>
  </div>
</template>

<script>
export default {
  props: ["leavePeriod", "columnWidth", "unityColumnWidth"],
  data() {
    return {};
  },
  methods: {
    showEvent(e, leavePeriod) {
      this.$emit("show-leave-period", leavePeriod);
    },
  },
};
</script>

<style lang="scss">
.event-card {
  border-radius: 5px;
  overflow: hidden;
  position: relative;
  height: var(--row-height);
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
}
.startAfternoon {
  margin-left: calc(var(--column-width) / 2);
}

.event-card p {
  width: 100%;
  height: 100%;
  padding: 1.5rem 0 0 5px;
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
  /* text-align: center; */
  color: rgb(36, 36, 36);
}
</style>
